import { useAccount, useConnect, useDisconnect } from 'wagmi'
import { useSolanaWallet } from '@/hooks/useSolanaWallet'
import { useSuiWallet } from '@/hooks/useSuiWallet'
import { clearAllLocalStorage } from '@/utils/localStorage'
import { useEffect, useState } from 'react'
import { WalletType } from '@/types/wallet'

export const useAppConnector = () => {

  const { address: evmAddress, isConnected: isEvmConnected } = useAccount()
  const { connect: connectEvm, connectors, isPending: isEvmConnecting } = useConnect()
  const { disconnect: disconnectEvm } = useDisconnect()
  const {
    isAvailable: isSolanaAvailable,
    isConnected: isSolanaConnected,
    isConnecting: isSolanaConnecting,
    publicKey: solanaAddress,
    connect: connectSolana,
    disconnect: disconnectSolana,
    walletAdapter: solanaWallet,
  } = useSolanaWallet()
  const {
    wallets: suiWallets,
    isAvailable: isSuiAvailable,
    isConnected: isSuiConnected,
    isConnecting: isSuiConnecting,
    publicKey: suiAddress,
    connect: connectSui,
    disconnect: disconnectSui,
    walletAdapter: suiWallet,
  } = useSuiWallet()
  const [activeWalletType, setActiveWalletType] = useState<WalletType | null>(() => {
    if (typeof window === 'undefined') {
      return null
    }
    const saved = window.localStorage.getItem('active_wallet_type')
    return saved === 'SOL' || saved === 'EVM' || saved === 'SUI' ? saved : null
  })

  const connect = async (provider: 'evm' | 'sol' | 'sui', connector?: any) => {
    console.log('call connect', provider, typeof connector, connector)
    if (provider === 'evm') {
      const connectorToUse = connector || connectors[0]
      console.log('connectorToUse', connectorToUse)
      if (!connectorToUse) {
        return
      }
      try {
        await connectEvm({ connector: connectorToUse })
        setActiveWalletType('EVM')
      } catch (error) {
        console.log('error', error)
      }
      return
    }

    if (provider === 'sol') {
      try {
        await connectSolana()
        setActiveWalletType('SOL')
      } catch (error) {
        console.log('error', error)
      }
      return
    }

    try {
      await connectSui(connector)
      setActiveWalletType('SUI')
    } catch (error) {
      console.log('error', error)
    }
  }

  function disconnectWallet () {
    disconnectSolana()
    disconnectSui()
    disconnectEvm()
    setActiveWalletType(null)
    clearAllLocalStorage()
  }
  useEffect(() => {
    if (activeWalletType === 'EVM' && !isEvmConnected && !isEvmConnecting) {
      setActiveWalletType(null)
    }
    if (activeWalletType === 'SOL' && !isSolanaConnected && !isSolanaConnecting) {
      setActiveWalletType(null)
    }
    if (activeWalletType === 'SUI' && !isSuiConnected && !isSuiConnecting) {
      setActiveWalletType(null)
    }
  }, [
    activeWalletType,
    isEvmConnected,
    isEvmConnecting,
    isSolanaConnected,
    isSolanaConnecting,
    isSuiConnected,
    isSuiConnecting,
  ])

  useEffect(() => {
    if (activeWalletType === 'EVM' && isEvmConnected && isSolanaConnected) {
      void disconnectSolana()
    }
    if (activeWalletType === 'SOL' && isEvmConnected && isSolanaConnected) {
      disconnectEvm()
    }
    if (activeWalletType === 'EVM' && isEvmConnected && isSuiConnected) {
      disconnectSui()
    }
    if (activeWalletType === 'SOL' && isEvmConnected && isSuiConnected) {
      disconnectSui()
    }
    if (activeWalletType === 'SUI' && isEvmConnected && isSolanaConnected) {
      disconnectEvm()
      void disconnectSolana()
    }
    if (activeWalletType === 'SUI' && isEvmConnected && isSuiConnected) {
      disconnectEvm()
    }
    if (activeWalletType === 'SUI' && isSolanaConnected && isSuiConnected) {
      void disconnectSolana()
    }
  }, [
    activeWalletType,
    isEvmConnected,
    isSolanaConnected,
    isSuiConnected,
    disconnectSolana,
    disconnectEvm,
    disconnectSui,
  ])

  return {
    evmAddress,
    solanaAddress,
    suiAddress,
    isSolanaAvailable,
    isSuiAvailable,
    isSolanaConnected,
    isSuiConnected,
    isEvmConnected,
    isSolanaConnecting,
    isSuiConnecting,
    connectors,
    isEvmConnecting,
    solanaWallet,
    suiWallets,
    suiWallet,
    connect,
    activeWalletType,
    disconnectWallet,
  }
}
